module.exports = __webpack_public_path__ + "static/cloak_of_the_manta_ray-1d6ffe5d2aa64717b25d6d070a6264b1.jpeg";